import queries from "../helpers/caseQueries";
import Modal from "../Components/modal";

import React, { useState, useMemo, useEffect, useCallback } from "react";
import { useForm } from "react-hook-form";
import { FiTrash2, FiPlus, FiEdit2 } from "react-icons/fi";
import AsyncSelect from "react-select/async";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { useApolloClient } from "@apollo/react-hooks";
import { withUser } from "../Contexts/user";
import { useSidebar } from "../Contexts/sidebar";


let timerId;

const Agency = ({ user }) => {
    const apollo = useApolloClient();
    const { isDarkMode } = useSidebar();
    const [createModalState, setCreateModalState] = useState(false);
    const [updateModalState, setUpdateModalState] = useState(false);
    const [selectedAgency, setSelectedAgency] = useState(null);


    const [paginationState, setPaginationState] = useState({
        limit: 30,
        page: 1,
        dir: "desc",
        by: "_id",
    });

    
    const [filters, setFilters] = useState({
        name: undefined,
    });

    const [appliedSearchVariables, setAppliedSearchVariables] = useState(() => ({
        _id: undefined,
    }));

    const handleSearch = () => {
        setAppliedSearchVariables({
            _id: filters._id,
        });
    };

    const [formKey, setFormKey] = useState(0);

    const {
        register,
        errors,
        handleSubmit,
        reset: resetForm,
    } = useForm({
        defaultValues: {
            name: "",
            projectDirector: undefined,
            salesDirector: undefined,
            propertyAgent: undefined,
        },
    });

    const filterSelectStyles = useMemo(
        () => ({
            control: (provided) => ({
                ...provided,
                borderColor: isDarkMode ? "#4B5563" : "#d1d5db",
                backgroundColor: isDarkMode ? "#374151" : "#ffffff",
                borderRadius: "0.5rem",
                minHeight: "38px",
                boxShadow: "none",
                "&:hover": {
                    borderColor: "#3b82f6",
                },
            }),
            placeholder: (provided) => ({
                ...provided,
                color: isDarkMode ? "#9CA3AF" : "#6b7280",
                fontSize: "0.875rem",
            }),
            menu: (provided) => ({
                ...provided,
                backgroundColor: isDarkMode ? "#374151" : "#ffffff",
                borderColor: isDarkMode ? "#4B5563" : "#e2e8f0",
            }),
            option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected
                    ? isDarkMode
                        ? "#1F2937"
                        : "#3B82F6"
                    : state.isFocused
                    ? isDarkMode
                        ? "#4B5563"
                        : "#F3F4F6"
                    : isDarkMode
                    ? "#374151"
                    : "#ffffff",
                color: state.isSelected
                    ? isDarkMode
                        ? "#D1D5DB"
                        : "#ffffff"
                    : isDarkMode
                    ? "#D1D5DB"
                    : "#1F2937",
            }),
            singleValue: (provided) => ({
                ...provided,
                color: isDarkMode ? "#D1D5DB" : "#1F2937",
            }),
            container: (provided) => ({
                ...provided,
                width: "100%",
            }),
        }),
        [isDarkMode]
    );

    const handleDeleteAgency = async (agencyId) => {
        if (!window.confirm("Are you sure you want to delete this agency?")) {
            return;
        }

        try {
            const result = await deleteAgency({
                variables: {
                    input: {
                        _id: agencyId,
                    },
                },
            });

            if (result.data) {
                refetchAgencies();
                alert("Agency deleted successfully");
            }
        } catch (err) {
            alert("Failed to delete agency");
            console.log(err);
        }
    };

    const {
        data: agenciesData,
        loading: agenciesLoading,
        refetch: refetchAgencies,
    } = useQuery(queries.FETCH_AGENCIES, {
        fetchPolicy: "network-only",
        variables: {
            limit: 30,
            page: 1,
            dir: "desc",
            by: "_id",
            status: "active",
            _id: appliedSearchVariables._id,
        },
        onError: ({ graphQLErrors, networkError }) => {
            if (graphQLErrors) {
                for (const graphQLError of graphQLErrors) {
                    console.log(graphQLError);
                }
            }

            if (networkError) {
                console.log(networkError);
            }
        },
    });

    const columns = useMemo(() => {
            return [
                {
                    Header: "Name",
                    accessor: "name",
                    Cell: ({ row: { original } }) => {
                        return (
                            <div>{original.name}</div>
                        )
                    },
                },
                {
                    Header: "Actions",
                    id: "actions",
                    Cell: ({ row: { original } }) => {
                        return (
                            <div className="flex items-center space-x-2">
                                {user.type !== "agent" && (
                                    <>
                                        <button
                                            onClick={() => handleEditAgency(original)}
                                            className="p-2 text-orange-500 hover:text-orange-700"
                                        >
                                            <FiEdit2 />
                                        </button>
                                        {(user.auth?.type ?? user.type) !== "manager" && (
                                            <button
                                                onClick={() => handleDeleteAgency(original._id)}
                                                className="p-2 text-orange-500 hover:text-orange-700"
                                            >
                                                <FiTrash2 />
                                            </button>
                                        )}
                                    </>
                                )}
                            </div>
                        );
                    },
                },
            ];
    }, [user.type, handleDeleteAgency]);

    const resetCreateModal = () => {
        setCreateModalState(false);
        resetForm();
    };

    const resetUpdateModal = () => {
        setUpdateModalState(false);
        setSelectedAgency(null);
        resetForm();
    };

    const handleEditAgency = (agency) => {
        setSelectedAgency(agency);
        setUpdateModalState(true);
    };

    const [createAgency] = useMutation(queries.CREATE_AGENCY);
    const [deleteAgency] = useMutation(queries.DELETE_AGENCY);
    const [updateAgency] = useMutation(queries.UPDATE_AGENCY);

    useEffect(() => {
        if (createModalState) {
            resetForm({
                name: "",
                });
        }
    }, [createModalState, resetForm]);

    useEffect(() => {
        if (updateModalState && selectedAgency) {
            resetForm({
                name: selectedAgency.name,
            });
        }
    }, [updateModalState, selectedAgency, resetForm]);

    const handleCreateAgency = async (formData) => {
        try {
            console.log("Form Data:", formData); // Debug log
            const result = await createAgency({
                variables: {
                    input: {
                        name: formData.name,
                    },
                },
            });

            if (result.data) {
                refetchAgencies();
                setCreateModalState(false);
                resetForm();
                alert("Agency created successfully");
            }
        } catch (err) {
            alert("Failed to create agency");
            console.log(err);
        }
    };

    const handleUpdateAgency = async (formData) => {
        try {
            console.log("Update Form Data:", formData); // Debug log
            const result = await updateAgency({
                variables: {
                    input: {
                        _id: selectedAgency._id,
                        name: formData.name,
                    },
                },
            });

            if (result.data) {
                refetchAgencies();
                setUpdateModalState(false);
                setSelectedAgency(null);
                resetForm();
                alert("Agency updated successfully");
            }
        } catch (err) {
            alert("Failed to update agency");
            console.log(err);
        }
    };



    const loadAgencies = useCallback(
        (val, callback) => {
            clearTimeout(timerId);
            timerId = setTimeout(async () => {
                const result = await apollo.query({
                    query: queries.FETCH_AGENCIES,
                    variables: {
                        name: val,
                        status: "active",
                        limit: 9999,
                        page: 1,
                    },
                    fetchPolicy: "network-only",
                });

                callback(
                    result.data.fetchAgencies.data.map((item) => ({
                        label: `${item.name}`,
                        value: item._id,
                    }))
                );
            }, 500);
        },
        [apollo]
    );

    return (
        <div
            className={`min-h-screen ${
                isDarkMode ? "bg-gray-900" : "bg-gray-50"
            }`}
        >
            <div className="px-4 py-8">
            <div className="flex justify-between items-center mb-6">
                <h1 className={`text-2xl font-bold ${isDarkMode ? 'text-white' : ''}`}>Agencies</h1>
                {user.type !== "agent" && (
                    <button
                        onClick={() => setCreateModalState(true)}
                        className={`flex items-center px-4 py-2 rounded text-white ${
                            isDarkMode
                                ? "bg-blue-600 hover:bg-blue-500"
                                : "bg-blue-500 hover:bg-blue-600"
                        }`}
                    >
                        <FiPlus className="mr-2" />
                        Add Agency
                    </button>
                )}
            </div>

            <div className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white'} rounded-lg shadow p-4 mb-6 border`} key={formKey}>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Agency Name
                        </label>
                        <AsyncSelect
                            styles={filterSelectStyles}
                            isSearchable={true}
                            loadOptions={(inputValue, callback) => {
                                if (!inputValue) {
                                    callback([]);
                                    return;
                                }
                                loadAgencies(inputValue, (options) => {
                                    const filteredOptions = options.filter(option => 
                                        option.label.toLowerCase().includes(inputValue.toLowerCase())
                                    );
                                    callback(filteredOptions);
                                });
                            }}
                            placeholder="Select Agency"
                            isClearable={true}
                            onChange={(selected) => {
                                setFilters(prev => ({
                                    ...prev,
                                    _id: selected?.value,
                                }));
                            }}
                        />
                    </div>

                    <div className="flex items-end gap-2 mb-4 flex-shrink-0">
                        <button
                            type="button"
                            onClick={handleSearch}
                            className={`px-4 py-2 rounded text-white ${
                                isDarkMode
                                    ? "bg-blue-600 hover:bg-blue-500"
                                    : "bg-blue-500 hover:bg-blue-600"
                            }`}
                        >
                            Search
                        </button>
                        <button
                            type="button"
                            onClick={() => {
                                setFilters({
                                    _id: undefined,
                                });
                                setAppliedSearchVariables({
                                    _id: undefined,
                                });
                                resetForm();
                                setFormKey(prev => prev + 1);
                            }}
                            className={`px-4 py-2 rounded text-white ${
                                isDarkMode
                                    ? "bg-gray-600 hover:bg-gray-500"
                                    : "bg-gray-500 hover:bg-gray-600"
                            }`}
                        >
                            Reset Filters
                        </button>
                    </div>
                </div>
            </div>

            <div className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white'} rounded-lg shadow overflow-hidden border overflow-x-auto`}>
                {agenciesLoading ? (
                    <div className="flex flex-col items-center justify-center py-24 px-4">
                        <div className="relative w-16 h-16 mb-4">
                            <div className="absolute inset-0 border-4 border-orange-200 rounded-full"></div>
                            <div className="absolute inset-0 border-4 border-orange-500 rounded-full border-t-transparent animate-spin"></div>
                        </div>
                        <p className={`font-medium ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}>
                            Loading agencies...
                        </p>
                        <p className={`text-sm mt-1 ${isDarkMode ? "text-gray-500" : "text-gray-400"}`}>
                            Please wait
                        </p>
                    </div>
                ) : (
                <>
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="text-black">
                        <tr className="bg-orange-400">
                            {columns.map((column) => (
                                <th
                                    key={column.Header}
                                    className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider"
                                >
                                    {column.Header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} divide-y divide-gray-200`}>
                        {agenciesData?.fetchAgencies?.data?.length > 0 ? agenciesData.fetchAgencies.data.map((agency) => (
                            <tr key={agency._id} className={`${isDarkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                                <td className={`px-6 py-4 whitespace-nowrap text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>{agency.name}</td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    {user.type !== "agent" && (
                                        <div className="flex space-x-2">
                                            <button
                                                onClick={() => handleEditAgency(agency)}
                                                className="text-orange-400 hover:text-orange-600"
                                            >
                                                <FiEdit2 />
                                            </button>
                                            {(user.auth?.type ?? user.type) !== "manager" && (
                                                <button
                                                    onClick={() => handleDeleteAgency(agency._id)}
                                                    className="text-orange-400 hover:text-orange-600"
                                                >
                                                    <FiTrash2 />
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </td>
                            </tr>
                        )) : (
                            <tr>
                                <td
                                    colSpan={2}
                                    className={`px-6 py-4 text-center ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}
                                >
                                    No agencies found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                    {agenciesData && agenciesData.fetchAgencies.pagination && (
                    <div className={`px-4 py-3 flex items-center justify-between border-t ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                        <div className="flex-1 flex justify-between items-center">
                            <div className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                Showing{' '}
                                <span className="font-medium">
                                    {((paginationState.page - 1) * paginationState.limit) + 1}
                                </span>
                                {' '}-{' '}
                                <span className="font-medium">
                                    {Math.min(paginationState.page * paginationState.limit, agenciesData.fetchAgencies.pagination.documents)}
                                </span>
                                {' '}of{' '}
                                <span className="font-medium">{agenciesData.fetchAgencies.pagination.documents}</span>
                                {' '}results
                            </div>
                            <div className="flex space-x-2">
                                <button
                                    onClick={() => setPaginationState(prev => ({ ...prev, page: 1 }))}
                                    disabled={paginationState.page === 1}
                                    className={`px-3 py-1 rounded-md text-sm font-medium ${
                                        paginationState.page === 1
                                            ? isDarkMode
                                                ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                                                : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-orange-400 text-white hover:bg-blue-600"
                                    }`}
                                >
                                    First
                                </button>
                                <button
                                    onClick={() => setPaginationState(prev => ({ ...prev, page: prev.page - 1 }))}
                                    disabled={paginationState.page === 1}
                                    className={`px-3 py-1 rounded-md text-sm font-medium ${
                                        paginationState.page === 1
                                            ? isDarkMode
                                                ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                                                : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-orange-400 text-white hover:bg-blue-600"
                                    }`}
                                >
                                    Previous
                                </button>
                                <span className={`px-3 py-1 rounded-md text-sm font-medium ${isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-900'}`}>
                                    Page {paginationState.page} of {agenciesData.fetchAgencies.pagination.totalPages}
                                </span>
                                <button
                                    onClick={() => setPaginationState(prev => ({ ...prev, page: prev.page + 1 }))}
                                    disabled={paginationState.page === agenciesData.fetchAgencies.pagination.totalPages}
                                    className={`px-3 py-1 rounded-md text-sm font-medium ${
                                        paginationState.page === agenciesData.fetchAgencies.pagination.totalPages
                                            ? isDarkMode
                                                ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                                                : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-orange-400 text-white hover:bg-blue-600"
                                    }`}
                                >
                                    Next
                                </button>
                                <button
                                    onClick={() => setPaginationState(prev => ({ ...prev, page: agenciesData.fetchAgencies.pagination.totalPages }))}
                                    disabled={paginationState.page === agenciesData.fetchAgencies.pagination.totalPages}
                                    className={`px-3 py-1 rounded-md text-sm font-medium ${
                                        paginationState.page === agenciesData.fetchAgencies.pagination.totalPages
                                            ? isDarkMode
                                                ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                                                : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-orange-400 text-white hover:bg-blue-600"
                                    }`}
                                >
                                    Last
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                </>
                )}
            </div>

            {createModalState && (
                <Modal reset={resetCreateModal}>
                    <div className="container h-full mx-auto flex justify-center items-center">
                        <div className={`panel p-6 rounded-md max-w-md w-full ${isDarkMode ? 'bg-gray-800 text-white' : 'bg-white'}`}>
                            <div className={`mb-4 text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Create Agency</div>
                            <form onSubmit={handleSubmit(handleCreateAgency)}>
                                <div className="mb-4">
                                    <label className={`block text-sm font-bold mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                        Agency Name
                                    </label>
                                    <input
                                        className={`my-2 p-3 w-full rounded-lg block border font-semibold text-xs ${
                                            isDarkMode 
                                                ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                                : 'bg-cool-gray border-gray-300 text-lynch'
                                        } ${
                                            errors.name
                                                ? "border-red-400" 
                                                : ""
                                        }`}
                                        name="name"
                                        ref={register({ required: true })}
                                        placeholder="Agency Name"
                                        type="text"
                                    />
                                    {errors.name && (
                                        <p className="text-red-500 text-xs italic">
                                            Agency name is required
                                        </p>
                                    )}
                                </div>

                                <button
                                    type="submit"
                                    className="bg-orange-400 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                >
                                    Create Agency
                                </button>
                            </form>
                        </div>
                    </div>
                </Modal>
            )}

            {updateModalState && selectedAgency && (
                <Modal reset={resetUpdateModal}>
                    <div className="container h-full mx-auto flex justify-center items-center">
                        <div className={`panel p-6 rounded-md max-w-md w-full ${isDarkMode ? 'bg-gray-800 text-white' : 'bg-white'}`}>
                            <div className={`mb-4 text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Update Agency</div>
                            <form onSubmit={handleSubmit(handleUpdateAgency)}>
                                <div className="mb-4">
                                    <label className={`block text-sm font-bold mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                        Agency Name
                                    </label>
                                    <input
                                        className={`my-2 p-3 w-full rounded-lg block border font-semibold text-xs ${
                                            isDarkMode 
                                                ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                                : 'bg-cool-gray border-gray-300 text-lynch'
                                        } ${
                                            errors.name
                                                ? "border-red-400" 
                                                : ""
                                        }`}
                                        name="name"
                                        ref={register({ required: true })}
                                        placeholder="Agency Name"
                                        type="text"
                                    />
                                    {errors.name && (
                                        <p className="text-red-500 text-xs italic">
                                            Agency name is required
                                        </p>
                                    )}
                                </div>

                                <div className="flex space-x-2">
                                    <button
                                        type="submit"
                                        className="bg-orange-500 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                    >
                                        Update Agency
                                    </button>
                                    <button
                                        type="button"
                                        onClick={resetUpdateModal}
                                        className="bg-gray-400 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </Modal>
            )}
            </div>
        </div>
    );
};

export default withUser(Agency);
